import ApiService from "../../utils/fetch";

const inboundOrderUrl = `${process.env.REACT_APP_BASE_URL}supply/orders/`;

export const fetchHeaderAndLinesData = async (orderType,orderNumber) => {
    const response = await ApiService.get(`${inboundOrderUrl}${orderNumber}?type=${orderType}`);
    return response.data;
};
export const fetchDeliveryData = async (orderNumber) => {
  const response = await ApiService.get(
    `${inboundOrderUrl}${orderNumber}/delivery?type=stockTransferPO`
  );
  return response.data;
};

export const fetchShipmentData = async (orderNumber) => {
  const response = await ApiService.get(
    `${inboundOrderUrl}${orderNumber}/shipment?type=stockTransferPO`
  );
  return response.data;
};
